module.exports = __webpack_public_path__ + "static/media/Download2.af914821.png";